import { NgModule } from '@angular/core';
import { LayoutThreeColumnsComponent } from './layout-three-columns.compnent';
import { CommonModule } from '@angular/common';
import { LayoutTwoColumnsComponent } from './layout-two-columns.component';
import { LayoutOneColumnComponent } from './layout-one-column.component';
import { LayoutTwoColumnsLargeComponent } from './layout-two-columns-large.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    LayoutThreeColumnsComponent,
    LayoutTwoColumnsComponent,
    LayoutTwoColumnsLargeComponent,
    LayoutOneColumnComponent,
  ],
  exports: [
    LayoutThreeColumnsComponent,
    LayoutTwoColumnsComponent,
    LayoutTwoColumnsLargeComponent,
    LayoutOneColumnComponent,
  ],
})
export class LayoutModule { }
